<template>
    <div class="px-10 lg:px-20 xl:px-32 pb-16" id="references">
        <h1 class="text-3xl md:text-5xl text-heading font-bold text-center text-black p-6 pb-8 md:pb-16 uppercase">
            {{ tr('references.title') }}
        </h1>

        <div class="flex flex-row flex-wrap"
             style="justify-content: space-evenly;"
        >
            <ReferenceItem v-for="(item, id) of visibleData"
                           :key="id"
                           :data="item"
                           @open="open"
            />

            <div class="text-center pt-16 xl:pb-0 h-full w-full whitespace-no-wrap sm:mt-8 lg-16 tablet:mt-0 uppercase font-extrabold font-condensed"
                 v-if="hasExpansion"
            >
                <div
                    @click.stop="expand"
                    class="bg-text p-3 pt-1 pb-1 text-xl text-2xl tablet:text-3xl text-white cursor-pointer inline-block elementHoverShadow"
                >
                    {{ tr(expanded ? 'references.showLess' : 'references.showMore') }}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {Translatable} from '@/data/translations';
import ReferenceItem from './baseComponents/ReferenceItem';

export default {
    name: 'References',
    mixins: [Translatable],
    components: {ReferenceItem},
    props: {
        data: Array,
    },
    data() {
        return {
            expanded: false,
        };
    },
    computed: {
        expandedLimit() {
            return 4;
        },
        hasExpansion() {
            return this.expandedLimit < this.data.length;
        },
        visibleData() {
            return this.expanded ? this.data : this.data.slice(0, this.expandedLimit);
        },
    },
    methods: {
        open(data) {
            this.$emit('open', data);
        },

        expand() {
            this.expanded = !this.expanded;
        },
    },
};
</script>

<style scoped>
</style>
